import { AttributeSkeleton } from '@app/components/various/AttributesList/AttributeSkeleton';

export const OrderInformationSkeleton = () => {
  return (
    <div className="flex flex-wrap items-center gap-x-10 gap-y-3 lg:gap-x-36">
      <AttributeSkeleton orientation="vertical" className="min-w-40 sm:min-w-56" />
      <AttributeSkeleton orientation="vertical" className="min-w-40 sm:min-w-56" />
      <AttributeSkeleton orientation="vertical" className="min-w-40 sm:min-w-56" />
    </div>
  );
};
